/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
// redux
import { useSelector } from 'react-redux'
// route
import { Route, Redirect, useLocation } from 'react-router-dom'
// services
import AuthService from '../../../modules/Auth/services/auth'
import { useHasPermission, useHasRoutePermission } from 'hooks/useHasPermission'

const PrivateRoute = ({ component: Component, validateRegister, codePermission, ...rest }) => {
	// redux
	const {
		session: { isLogin }
	} = useSelector(state => state)

	const { pathname } = useLocation()

	const hasRoutePermission = useHasRoutePermission({ route: pathname })
	const hasPermission = codePermission ? useHasPermission({ code: codePermission }) : true

	const hasAllPermission =
		isLogin && AuthService.isLoggedIn(validateRegister) && hasPermission && hasRoutePermission

	return (
		<Route
			{...rest}
			render={props => (hasAllPermission ? <Component {...props} /> : <Redirect to='/' />)}
		/>
	)
}

export default PrivateRoute
